import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button, SelecaoMultipla } from '../../components';
import { trataMensagensErro, requestSalvaComplementoTitulo, requestApagaComplementoTitulo } from '../../utils/requests';
import { visoesSimulacaoCompensacao, tipoRegime, tipoEntidadeSimulacaoCompensacao } from '../../utils/listsSelect';
import { ehPapelObservadorRelatorio } from '../../utils/helpers';
import SelecaoEntidade from './SelecaoEntidade';

const VAZIO = '';
const participanteRGPS = '01000';

const rowStyle = {
  width: '2px',
  paddingRigth: '10px',
};
const spanStyle = {
  margin: '0px',
  position: 'relative',
  color: '#44707B',
  top: '25px',
  padding: '5px',
};

class FiltroSimulacaoCompensacao extends Component {
  constructor() {
    super();
    this.filtroSimulacaoCompensacao = JSON.parse(sessionStorage.getItem('filtroSimulacaoCompensacao'));

    this.state = {
      visaoSimulacaoCompensacao: this.filtroSimulacaoCompensacao &&
      this.filtroSimulacaoCompensacao.visaoSimulacaoCompensacao ?
        this.filtroSimulacaoCompensacao.visaoSimulacaoCompensacao : null,
      estadoCompensacao: this.filtroSimulacaoCompensacao &&
      this.filtroSimulacaoCompensacao.estadoCompensacao ?
        this.filtroSimulacaoCompensacao.estadoCompensacao : null,
      participanteLogado: this.participanteLogado &&
      this.filtroSimulacaoCompensacao.participanteLogado ?
        this.filtroSimulacaoCompensacao.participanteLogado : null,
      'destinatario-rpps':
      this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao['destinatario-rpps'] ?
        this.filtroSimulacaoCompensacao['destinatario-rpps'] : null,
      cliqueiNoBotao:
        this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.cliqueiNoBotao ?
          this.filtroSimulacaoCompensacao.cliqueiNoBotao : null,
      tipoEntidade:
      this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.tipoEntidade ?
        this.filtroSimulacaoCompensacao.tipoEntidade : null,
      uf:
      this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.uf ?
        this.filtroSimulacaoCompensacao.uf : null,
      exibirCampoNome:
        this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.exibirCampoNome ?
          this.filtroSimulacaoCompensacao.exibirCampoNome : false,
      complementoTitulo:
        this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.complementoTitulo ?
          this.filtroSimulacaoCompensacao.complementoTitulo : '',
      validadeCampos: {
        visaoSimulacaoCompensacao: false,
      },
      lista: this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.lista ?
        this.filtroSimulacaoCompensacao.lista : [],
      configComponenteSelecaoMultipla: this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.configComponenteSelecaoMultipla ?
        this.filtroSimulacaoCompensacao.configComponenteSelecaoMultipla : null,
      configuracao: {
        origem: 'filtroSimulacaoCompensacao',
        labelCombobox: 'Estado para simulação de compensação',
        titulo: '',
        exibirBotaoIncluir: true,
        exibirTabelaItens: true,
        retirarLinhaSeparadora: true,
        exibirComboBox: true,
      },
      tipoRegimeObservador: this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.tipoRegimeObservador ?
        this.filtroSimulacaoCompensacao.tipoRegimeObservador : null,
      tipoEntidadeObservador: this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.tipoEntidadeObservador ?
        this.filtroSimulacaoCompensacao.tipoEntidadeObservador : null,
      uFObservador: this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.uFObservador ?
        this.filtroSimulacaoCompensacao.uFObservador : null,
      participanteObservador: this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.participanteObservador ?
        this.filtroSimulacaoCompensacao.participanteObservador : null,
      listaTiposRegimes: [],
      listaTiposRegimesOutrosPapeis: [],
      pesquisarRequerimentosNaoAptos: this.filtroSimulacaoCompensacao && this.filtroSimulacaoCompensacao.pesquisarRequerimentosNaoAptos ?
        this.filtroSimulacaoCompensacao.pesquisarRequerimentosNaoAptos : false,
      limparFiltro: false,
    };
  }

  componentDidMount() {
    // if (sessionStorage.getItem('filtroSimulacaoCompensacao')) {
    //   this.handleSearchButton();
    // }
    sessionStorage.removeItem('filtroSimulacaoCompensacao');
    requestApagaComplementoTitulo();
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.tipoConsulta !== prevProps.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  preparaNovaConsulta = () => {
    let filtroSimulacaoCompensacao = {
      visaoSimulacaoCompensacao: null,
      estadoCompensacao: null,
      'destinatario-rpps': null,
      tipoEntidade: null,
      uf: null,
      lista: [],
      pesquisarRequerimentosNaoAptos: false,
    };

    filtroSimulacaoCompensacao = JSON.stringify(filtroSimulacaoCompensacao);
    sessionStorage.setItem('filtroSimulacaoCompensacao', filtroSimulacaoCompensacao);

    this.setState({
      visaoSimulacaoCompensacao: null,
      estadoCompensacao: null,
      'destinatario-rpps': null,
      tipoEntidade: null,
      uf: null,
      lista: [],
      pesquisarRequerimentosNaoAptos: false,
    });
  }

  filtrarRegimes = () => {
    let retorno = this.state.listaTiposRegimes;
    if (this.props.papelUsuarioLogado === 'analista-rgps' ||
    (this.state.tipoRegimeObservador === 1 && ehPapelObservadorRelatorio(this.props.papelUsuarioLogado))) {
      retorno = this.state.listaTiposRegimes.filter(item => (item.label !== 'RGPS'));
    }
    if (this.props.papelUsuarioLogado !== 'analista-rgps' ||
    (this.state.tipoRegimeObservador === 2 && ehPapelObservadorRelatorio(this.props.papelUsuarioLogado))) {
      retorno = tipoRegime;
    }
    this.setState({ listaTiposRegimes: retorno });
  }

  handleChange = (changeObj, name) => {
    if (name === 'visaoSimulacaoCompensacao') {
      this.setState({ complementoTitulo: this.montaComplementoTitulo(changeObj.value) });
    }
    if (name === 'tipoRegimeObservador') {
      if (changeObj.value === 1) {
        this.setState({ participanteObservador: participanteRGPS });
      }
      this.setState({ tipoRegimeObservador: changeObj.value }, this.filtrarRegimes);
    }
    if (name === 'participanteObservador') {
      this.props.recuperarCnpjParticipanteComoObservador(changeObj.value);
    }

    this.setState({
      [name]: changeObj.value,
    }, () => this.trataFormulario(name));
  }

  handleKeyDown = (e) => {
    let retorno = null;
    if (e.keyCode === 13) {
      retorno = this.handleSearchButton();
    }
    return retorno;
  }

  /**
   * Encaminha para as funcoes que tratam alteracoes em cada campo
   */
  trataFormulario = (campoAlterado) => {
    if (campoAlterado === 'tipoEntidade') {
      this.trataTipoEntidade();
    }
    if (campoAlterado === 'uf') {
      this.trataUf();
    }
    if (campoAlterado === 'visaoSimulacaoCompensacao') {
      let complementoTitulo = {
        complementoTitulo: this.state.complementoTitulo,
      };
      complementoTitulo = JSON.stringify(complementoTitulo);
      requestSalvaComplementoTitulo(complementoTitulo);
    }
  }

  trataUf = () => {
    this.setState({ 'destinatario-rpps': null, exibirCampoNome: true });
  }

  trataTipoEntidade = () => {
    const paramTipoEntidade = this.state.tipoEntidade;
    this.setState({
      'destinatario-rpps': null,
      uf: null,
      exibirCampoNome: (paramTipoEntidade === 1 || paramTipoEntidade === 3),
    });
  }

  handleSearchButton = () => {
    let filtroSimulacaoCompensacao = {};
    if (this.state.tipoEntidade === participanteRGPS) {
      filtroSimulacaoCompensacao = {
        visaoSimulacaoCompensacao: this.state.visaoSimulacaoCompensacao,
        estadoCompensacao: this.state.estadoCompensacao,
        lista: this.state.lista,
        'destinatario-rpps': participanteRGPS,
        tipoEntidade: 1,
        pesquisarRequerimentosNaoAptos: this.state.pesquisarRequerimentosNaoAptos,
      };
    } else {
      filtroSimulacaoCompensacao = {
        visaoSimulacaoCompensacao: this.state.visaoSimulacaoCompensacao,
        estadoCompensacao: this.state.estadoCompensacao,
        'destinatario-rpps': this.state['destinatario-rpps'],
        tipoEntidade: this.state.tipoEntidade,
        uf: this.state.uf,
        lista: this.state.lista,
        tipoRegimeObservador: this.state.tipoRegimeObservador,
        tipoEntidadeObservador: this.state.tipoEntidadeObservador,
        uFObservador: this.state.uFObservador,
        participanteObservador: this.state.participanteObservador,
        pesquisarRequerimentosNaoAptos: this.state.pesquisarRequerimentosNaoAptos,
      };
    }
    this.setState(
      {
        cliqueiNoBotao: 1,
      },
      () => {
        this.handleChange({
          value: 1,
          isValid: true,
        }, 'cliqueiNoBotao');
      },
    );
    filtroSimulacaoCompensacao = JSON.stringify(filtroSimulacaoCompensacao);
    sessionStorage.setItem('filtroSimulacaoCompensacao', filtroSimulacaoCompensacao);
    this.handleSearch();
  }

  handleKeyUp = (e) => {
    let retorno = e.target.value;
    retorno = this.formatarValorMonetario(retorno);
    e.target.value = retorno;
    return retorno;
  }

  handleLimparFiltro = () => {
    this.setState({
      visaoSimulacaoCompensacao: null,
      estadoCompensacao: null,
      'destinatario-rpps': null,
      tipoEntidade: null,
      uf: null,
      lista: [],
      tipoRegimeObservador: null,
      tipoEntidadeObservador: null,
      uFObservador: null,
      participanteObservador: null,
      pesquisarRequerimentosNaoAptos: false,
      valorComboSelecaoMultipla: null,
      exibirCampoNome: false,
      limparFiltro: true,
    }, this.props.verificarSeListaConsultaPreenchida(true));

    if (sessionStorage.getItem('filtroSimulacaoCompensacao')) {
      sessionStorage.removeItem('filtroSimulacaoCompensacao');
    }

    if (document.getElementById('naoAptos').checked === true) {
      document.getElementById('naoAptos').checked = false;
      document.getElementById('naoAptos').click();
    }
  }

  handleSearch = () => {
    // visao é obrigatório
    if (this.state.visaoSimulacaoCompensacao) {
      if (this.state.tipoEntidade) {
        if (this.state.tipoEntidade === 2 && !this.state.uf && !this.state['destinatario-rpps']) {
          trataMensagensErro(['Escolha uma UF']);
          return;
        }
        this.props.handleSearchFilter(this.state);
      } else {
        this.props.handleSearchFilter(this.state);
      }
    } else {
      trataMensagensErro(['É necessario informar a visão.']);
    }
  }

  // verificarSeListaConsultaPreenchida = () => {
  //   this.props.handleSearchFilter(this.state);
  // }

  listaFiltradaDestinatarios = () => {
    const listaOrgaosFederais = [];
    let listaParticipantes = this.props.destinatarios.filter((item) => {
      // if (item.inOrgaoCentralizador === 1) {
      //   listaOrgaosFederais.push(item);
      // } else if (!(item.inOrgaoExtinto) &&
      //   ((item.tipoRegimeProprio === this.state.tipoEntidade && ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)))) {
      //   return item;
      // }
      // return null;
      if ((item.inOrgaoUniao) && (((!item.inOrgaoExtinto) && item.inOrgaoCentralizador === 1) || ((!item.inOrgaoExtinto) && item.inOrgaoCentralizador === 0))) {
        listaOrgaosFederais.push(item);
      } else if ((!item.inOrgaoExtinto) &&
        ((item.tipoRegimeProprio === this.state.tipoEntidade && ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)))) {
        return item;
      }
      return null;
    });
    if (listaOrgaosFederais.length > 0 && this.state.tipoEntidade === 1) {
      listaParticipantes = listaOrgaosFederais;
    }
    return listaParticipantes;
  }

  carregaUfDosMunicipios = () => {
    const listaUf = [];
    this.props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  }

  montaComplementoTitulo = (visao) => {
    let complemento = '';
    if (visao && visao !== '' && visao !== undefined) {
      if (visao === 1) {
        complemento = 'Previsão de Valores a Receber';
      } else {
        complemento = 'Previsão de Valores a Pagar';
      }
    }
    return complemento;
  }

  montaFiltros() {
    return (
      <React.Fragment>
        {ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) ?
          <SelecaoEntidade
            handleChange={this.handleChange}
            destinatarios={this.props.destinatarios}
            papelUsuarioLogado={this.props.papelUsuarioLogado}
            titulo="Visualizar como"
            retirarLinhaSeparadora={false}
            tipoRegime={this.state.tipoRegimeObservador}
            tipoEntidade={this.state.tipoEntidadeObservador}
            uf={this.state.uFObservador}
            participante={this.state.participanteObservador}
            nomeAtributoComboboxRegime="tipoRegimeObservador"
            nomeAtributoComboboxParticipante="participanteObservador"
            nomeAtributoComboboxTipoEntidade="tipoEntidadeObservador"
            nomeAtributoComboboxUF="uFObservador"
            listaTiposRegimes={tipoRegime}
            labelComboboxParticipante="Participante Observador"
          />
        : '' }
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              label="Visão"
              required
              onChange={e => this.handleChange(e, 'visaoSimulacaoCompensacao')}
              value={this.state.visaoSimulacaoCompensacao}
              itemList={visoesSimulacaoCompensacao}
              placeholder="Selecione a Visão"
              number
              custom
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              label="Tipo de Entidade"
              onChange={e => this.handleChange(e, 'tipoEntidade')}
              placeholder="Selecione a Entidade"
              value={this.state.tipoEntidade}
              itemList={tipoEntidadeSimulacaoCompensacao}
              custom
              number
            />
          </Grid>
          {this.state.tipoEntidade === 2 ? (
            <Grid cols="4 4 4 4">
              <Input
                label="UF"
                onChange={e => this.handleChange(e, 'uf')}
                placeholder="Selecione a UF"
                value={this.state.uf}
                itemList={this.carregaUfDosMunicipios()}
                custom
              />
            </Grid>
          ) : ''}
          {this.state.exibirCampoNome ? (
            <Grid cols="4 4 4 4">
              <Input
                label={this.state.visaoSimulacaoCompensacao === 1 ? 'Nome do Destinatário' : 'Nome do Solicitante'}
                name="destinatario-rpps"
                onChange={e => this.handleChange(e, 'destinatario-rpps')}
                placeholder={this.state.visaoSimulacaoCompensacao === 1 ? 'Selecione o Destinatário' : 'Selecione o Solicitante'}
                value={this.state['destinatario-rpps']}
                itemList={this.listaFiltradaDestinatarios()}
                custom
              />
            </Grid>
          ) : ''}
        </div>
        <div className="row" >
          <Grid cols="1 1 1 1" style={rowStyle}>
            <div >
              <Input
                id="naoAptos"
                onChange={e => this.handleChange(e, 'pesquisarRequerimentosNaoAptos')}
                check
                value={this.state.pesquisarRequerimentosNaoAptos}
              />
            </div>
          </Grid>
          <span style={spanStyle}>
            Requerimentos que não foram aptos para realizar a simulação.
          </span>
        </div>
        <div>
          <SelecaoMultipla
            handleChange={this.handleChange}
            configuracao={this.state.configuracao}
            estado={this.state.estado}
            hint="Estado para simulação de compensação"
            listaEstadosComSelecaoMultipla={[]}
            lista={this.state.lista}
            valorComboSelecaoMultipla={this.state.valorComboSelecaoMultipla}
          />
        </div>
      </React.Fragment>
    );
  }

  formularioProntoParaEnvio = () => {
    const { visaoSimulacaoCompensacao } = { ...this.state };
    let retorno = false;

    if (visaoSimulacaoCompensacao !== null && visaoSimulacaoCompensacao !== VAZIO) {
      retorno = true;
    }
    return retorno;
  }

  verificarSeAlgumCampoPreenchido = () => {
    const {
      visaoSimulacaoCompensacao,
      tipoEntidade,
      uf,
      pesquisarRequerimentosNaoAptos,
      valorComboSelecaoMultipla,
      lista,
    } = { ...this.state };

    let retorno = true;

    const visaoSimulacaoCompensacaoSelecionado = (visaoSimulacaoCompensacao !== null && visaoSimulacaoCompensacao !== VAZIO && visaoSimulacaoCompensacao !== undefined);

    if (visaoSimulacaoCompensacaoSelecionado) {
      retorno = false;
    }

    if (tipoEntidade !== null && tipoEntidade !== VAZIO) {
      retorno = false;
    }

    if (uf !== null && uf !== VAZIO) {
      retorno = false;
    }

    if (pesquisarRequerimentosNaoAptos === true) {
      retorno = false;
    }

    const valorComboSelecaoMultiplaSelecionado = (valorComboSelecaoMultipla !== null && valorComboSelecaoMultipla !== VAZIO && valorComboSelecaoMultipla !== undefined);
    if (valorComboSelecaoMultiplaSelecionado) {
      retorno = false;
    }

    if (lista !== null && lista.length > 0) {
      retorno = false;
    }

    return retorno;
  }

  render() {
    const filtrosPesquisa = this.montaFiltros();
    if (!filtrosPesquisa) {
      return null;
    }

    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="pesquisa"
          panelId="filtro-pesquisa"
          icon="ico-filter"
          title="simulação de compensação"
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              disabled={!this.formularioProntoParaEnvio()}
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
            <Button
              // disabled={this.verificarSeAlgumCampoPreenchido()}
              className="right"
              title="limpar"
              onClick={() => this.handleLimparFiltro()}
              hint="limpar o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroSimulacaoCompensacao.propTypes = {
  destinatarios: PropTypes.arrayOf().isRequired,
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
  estadosSimulacaoCompensacao: PropTypes.arrayOf().isRequired,
  estadosSimulacaoCompensacaoObservador: PropTypes.arrayOf().isRequired,
  papelUsuarioLogado: PropTypes.string,
  recuperarCnpjParticipanteComoObservador: PropTypes.func,
  verificarSeListaConsultaPreenchida: PropTypes.func,
}.isRequired;

export default FiltroSimulacaoCompensacao;



// WEBPACK FOOTER //
// ./src/pages/relatorios/FiltroSimulacaoCompensacao.jsx